import React, { useEffect, createElement } from 'react';
import { X, Download } from 'lucide-react';
interface LeadModalProps {
  open: boolean;
  onClose: () => void;
}
export function LeadModal({
  open,
  onClose
}: LeadModalProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      // Inject GHL form embed script if not already present
      const existing = document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]');
      if (!existing) {
        const script = document.createElement('script');
        script.src = 'https://link.msgsndr.com/js/form_embed.js';
        script.async = true;
        document.body.appendChild(script);
      }
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [open, onClose]);
  if (!open) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-bunker/80 backdrop-blur-md overflow-y-auto" onClick={onClose} role="dialog" aria-modal="true" data-id="element-51">
      <div className="relative bg-earth w-full max-w-lg my-8 rounded-3xl shadow-2xl shadow-bunker/40 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-52">
        <button onClick={onClose} className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-bunker/5 text-bunker/60 hover:bg-bunker/10 hover:text-pitahaya transition-all z-10" aria-label="Cerrar" data-id="element-53">
          <X className="w-5 h-5" data-id="element-54" />
        </button>

        <div className="p-6 md:p-8" data-id="element-55">
          <div className="inline-flex items-center gap-2 mb-4 bg-pitahaya/10 px-3 py-1.5 rounded-full" data-id="element-56">
            <Download className="w-4 h-4 text-pitahaya" data-id="element-57" />
            <span className="text-pitahaya font-sans font-bold text-[11px] tracking-widest uppercase" data-id="element-58">
              Acceso Gratuito
            </span>
          </div>

          <h3 className="font-serif text-2xl md:text-3xl font-bold text-bunker leading-tight mb-3" data-id="element-59">
            Descarga la{' '}
            <span className="text-pitahaya" data-id="element-60">Guía de Blindaje Patrimonial</span>{' '}
            y agenda tu entrevista privada
          </h3>

          <p className="font-sans text-bunker/60 text-sm mb-5 leading-relaxed" data-id="element-61">
            Recibe la guía en tu correo y un asesor te contactará en menos de 24
            horas para agendar tu sesión estratégica sin costo.
          </p>

          {/* GHL Embedded Form */}
          <div className="rounded-2xl overflow-hidden bg-earth" style={{
          height: '430px'
        }} data-id="element-62">
            <iframe src="https://api.leadconnectorhq.com/widget/form/ioii3pNW1ltvKTZ26wa2" style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: '0',
            backgroundColor: '#FAFAF7'
          }} id="inline-ioii3pNW1ltvKTZ26wa2" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="VSL Pithaya" data-height="468" data-layout-iframe-id="inline-ioii3pNW1ltvKTZ26wa2" data-form-id="ioii3pNW1ltvKTZ26wa2" title="VSL Pithaya" data-id="element-63" />
          </div>

          <p className="text-center font-sans text-xs text-bunker/50 pt-4" data-id="element-64">
            🔒 Tus datos están protegidos. No compartimos tu información.
          </p>
        </div>
      </div>
    </div>;
}